/*
 * @Descripttion: 
 * @version: v0.0.1
 * @Author: ZhouYanPing
 * @Date: 2021-06-07 09:17:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-29 13:35:35
 */
import {config, request} from 'Utils';

// 返利单列表
export function rebateBillList(param) {
    return request(`${config.server}/api/v1/dms/settle/order/list`, {
        method: 'post',
        body: param
    });
}

// 一键导入返利单
export function rebateBillImport(param) {
    return request(`${config.server}/api/v1/dms/settle/order/import`, {
        method: 'post',
        body: param
    });
}

// 撤回
export function rebateBillBack(param) {
    return request(`${config.server}/api/v1/dms/settle/order/revocation/` + param.id, {
        method: 'post',
        body: null
    });
}

// 发送
export function rebateBillSend(param) {
    return request(`${config.server}/api/v1/dms/settle/order/send/` + param.id, {
        method: 'post',
        body: null
    });
}

// 发送电子签
export function rebateBillSendEsign(param) {
    return request(`${config.server}/api/v1/dms/settle/order/sendEsign/` + param.id, {
        method: 'post',
        body: null
    });
}

// 查看电子签
export function rebateBillViewEsign(param) {
    return request(`${config.server}/api/v1/dms/settle/order/viewEsign/` + param.id, {
        method: 'post',
        body: null
    });
}

// 确认/驳回返利单
export function rebateBillConfirmOrReject(param) {
    return request(`${config.server}/api/v1/dms/settle/order/confirmOrReject`, {
        method: 'post',
        body: param
    });
}

// 附件统一上传后保存上传路径
export function rebateBillUpload(param) {
    return request(`${config.server}/api/v1/dms/settle/order/upload`, {
        method: 'post',
        body: param
    });
}

// 获取所有折扣明细类
export function getDiscountType(param) {
    return request(`${config.server}/api/v1/dms/settle/order/getDiscountType`, {
        method: 'get',
        body: param
    });
}

// 返利详情查看
export function getRebateBillDetail(param) {
    return request(`${config.server}/api/v1/dms/settle/order/detail`, {
        method: 'get',
        body: param
    });
}

// 扫描件下载
export function rebateBillDownload(param) {
    return request(`${config.server}/api/v1/dms/settle/order/download`, {
        method: 'get',
        body: param
    });
}

// 一键发送
export function rebateBillSendAll(param) {
    return request(`${config.server}/api/v1/dms/settle/order/sendAll/` + param, {
        method: 'post',
        body: null
    });
}

// 客户未上传提醒接口
export function getBillMessage(param) {
    return request(`${config.server}/api/v1/dms/settle/order/getMessage`, {
        method: 'get',
        body: param
    });
}


// WEBPACK FOOTER //
// ./src/service/rebateBillManage/index.js